import React, { useState, useRef } from 'react';
import PropTypes, { arrayOf } from 'prop-types';
import RightSidePopup from './RightSidePopup';
import WrapperVariant1 from '../WrapperVariant1/WrapperVariant1';
import WrapperVariant2 from '../WrapperVariant2/WrapperVariant2';
import Wrapper from '../RecycleAndInstall/components/Wrapper/Wrapper';
import {
  trackGeneralEvent,
  trackProductAttachmentsPopupDisplayed,
  trackPSAServicesDisplayed,
  trackPSAServiceToBasket,
  trackPSAServiceOffBasket
} from '../../../../../analytics';
import { fetchAttachments } from '../../helpers/fetchAttachments';
import { fetchMainProductData } from '../../helpers/fetchMainProductData';
import { fetchServices } from '../../helpers/fetchServices';
import { addServiceToBasket, removeServiceFromBasket } from '../../helpers/addServiceToBasket';

export const PSA_SWITCHED_OFF = 'psa_switched_off';
export const PSA_VARIANT_1 = 'psa_variant_1';
export const PSA_VARIANT_2 = 'psa_variant_2';
export const PSA_VARIANT_3 = 'psa_variant_3';

export const psaVariants = {
  0: PSA_SWITCHED_OFF,
  1: PSA_VARIANT_1,
  2: PSA_VARIANT_2,
  3: PSA_VARIANT_3
};

export const RI_TYPE_RECYCLING = 'recycling';
export const RI_TYPE_INSTALLATION = 'installation';
const RI_ACTION_ADD = 'ri_action_add';
const RI_ACTION_REMOVE = 'ri_action_remove';
const RI_STATE_IN_PROGRESS = 'ri_state_in_progress';
const RI_STATE_SUCCESS = 'ri_state_success';
const RI_STATE_FAILURE = 'ri_state_failure';

const ANALYTICS_BUNDLE_TYPE_WBW = 'psa wbw';

export const ON_PSA_MAIN_PRODUCT_ADDED = 'onPSAMainProductAdded';

const PSAPopup = (props) => {
  const {
    psaVariant,
    recycleAndInstallEnabled,
    psaWhenBoughtWithEnabled,
    productID,
    mainProductData,
    staticBundleSubProducts,
    storeUrl,
    hideHeaderBar,
    attachmentsLabel,
    continueToBasketButtonLabel,
    continueShoppingButtonLabel,
    addAttachmentInBasketLabel,
    addAttachmentInBasketInProgressLabel,
    attachmentAddedInBasketLabel,
    basketInfoLabel1,
    basketInfoLabel2Singular,
    basketInfoLabel2Plural,
    headerItemLabel,
    headerBundleLabel,
    recyclingLabel,
    installationLabel,
    recyclingHelpText,
    installationHelpText,
    weHelpHeadingLabel,
    failedToUpdateBasket,
    pleaseTryAgain,
    addButtonLabel,
    removeButtonLabel,
    moreInfoLabel,
    forceVisible
  } = props;

  const basketRedirectUrlRef = useRef(null);
  const [isVisible, setVisible] = useState(forceVisible);
  const [attachmentsData, setAttachmentsData] = useState(null);
  const attachmentsDataRef = useRef(null);
  const [storeId, setStoreId] = useState(null);
  const [deliveryType, setDeliveryType] = useState(null);
  const servicesDataRef = useRef(null);
  const [recycleAndInstallDisplayed, setRecycleAndInstallDisplayed] = useState(false);
  const [installationData, setInstallationData] = useState(null);
  const installationDataRef = useRef(null);
  const [recyclingData, setRecyclingData] = useState(null);
  const recyclingDataRef = useRef(null);
  const basketIdRef = useRef(null);
  const recyclingAddedRef = useRef(false);
  const installationAddedRef = useRef(false);
  const [recyclingInProgress, setRecyclingInProgress] = useState(false);
  const [installationInProgress, setInstallationInProgress] = useState(false);
  const [recyclingFailed, setRecyclingFailed] = useState(false);
  const [installationFailed, setInstallationFailed] = useState(false);
  const [mainProduct, setMainProduct] = useState(null);
  const mainProductRef = useRef(null);
  const [isProductBundle, setProductBundle] = useState(false);
  const [subproductNames, setSubproductNames] = useState([]);
  const [productIdForFailedAddToBasket, setProductIdForFailedAddToBasket] = useState('');
  const [attachmentsAddedToBasket, setAttachmentsAddedToBasket] = useState([]);
  const [whenBoughtWithPossible, setWhenBoughtWithPossible] = useState(false);

  const loadMainProductData = async (storeUrl, mainProductId) => {
    try {
      const mainProduct = await fetchMainProductData(storeUrl, mainProductId);
      setMainProduct(mainProduct);
      mainProductRef.current = mainProduct;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('An error occured, when loading main product data.', e);
    }
  };
  const loadAttachments = async (storeUrl, mainProductId) => {
    try {
      const attachments = await fetchAttachments(storeUrl, mainProductId);
      setAttachmentsData(attachments);
      attachmentsDataRef.current = attachments;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('An error occured, when loading attachments.', e);
    }
  };

  const loadServices = async (storeUrl, mainProductId) => {
    try {
      const services = await fetchServices(storeUrl, mainProductId);
      servicesDataRef.current = services;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('An error occured, when loading services.', e);
    }
  };

  // eslint-disable-next-line max-len
  // Removes from attachments products of same category (segment) as those added to basket : PREXA-43
  const filterAttachmentsBySegmentIds = (attachments, segmentIds = []) => attachments
    .filter((attachment) => !segmentIds.includes(attachment.segmentId));

  const changeAddRemoveButtonLabel = (action, type) => {
    let buttonLabel;
    if (action === RI_ACTION_ADD) {
      buttonLabel = removeButtonLabel;
    }
    if (action === RI_ACTION_REMOVE) {
      buttonLabel = addButtonLabel;
    }
    if (buttonLabel) {
      if (type === RI_TYPE_INSTALLATION) {
        setInstallationData({
          ...installationDataRef.current,
          buttonText: buttonLabel
        });
      }
      if (type === RI_TYPE_RECYCLING) {
        setRecyclingData({
          ...recyclingDataRef.current,
          buttonText: buttonLabel
        });
      }
    }
  };

  const setServiceAdded = (type, action) => {
    if (action === RI_ACTION_ADD) {
      if (type === RI_TYPE_INSTALLATION) {
        installationAddedRef.current = true;
      }
      if (type === RI_TYPE_RECYCLING) {
        recyclingAddedRef.current = true;
      }
    }
    if (action === RI_ACTION_REMOVE) {
      if (type === RI_TYPE_INSTALLATION) {
        installationAddedRef.current = false;
      }
      if (type === RI_TYPE_RECYCLING) {
        recyclingAddedRef.current = false;
      }
    }
  };

  const changeAddRemoveState = (type, action, state) => {
    if (type === RI_TYPE_INSTALLATION && state === RI_STATE_IN_PROGRESS) {
      setInstallationFailed(false);
      setInstallationInProgress(true);
    }
    if (type === RI_TYPE_RECYCLING && state === RI_STATE_IN_PROGRESS) {
      setRecyclingFailed(false);
      setRecyclingInProgress(true);
    }
    if (type === RI_TYPE_INSTALLATION && state === RI_STATE_SUCCESS) {
      setInstallationFailed(false);
      setInstallationInProgress(false);
      changeAddRemoveButtonLabel(action, type);
      setServiceAdded(type, action);
    }
    if (type === RI_TYPE_RECYCLING && state === RI_STATE_SUCCESS) {
      setRecyclingFailed(false);
      setRecyclingInProgress(false);
      changeAddRemoveButtonLabel(action, type);
      setServiceAdded(type, action);
    }
    if (type === RI_TYPE_INSTALLATION && state === RI_STATE_FAILURE) {
      setInstallationFailed(true);
      setInstallationInProgress(false);
    }
    if (type === RI_TYPE_RECYCLING && state === RI_STATE_FAILURE) {
      setRecyclingFailed(true);
      setRecyclingInProgress(false);
    }
  };

  const detectAction = (type) => {
    let action;
    if (
      (type === RI_TYPE_INSTALLATION && !installationAddedRef.current) ||
      (type === RI_TYPE_RECYCLING && !recyclingAddedRef.current)
    ) {
      action = RI_ACTION_ADD;
    } else if (
      basketIdRef.current &&
      ((type === RI_TYPE_INSTALLATION && installationAddedRef.current) ||
        (type === RI_TYPE_RECYCLING && recyclingAddedRef.current))
    ) {
      action = RI_ACTION_REMOVE;
    }
    return action;
  };

  const handleAddRemoveService = async (type, storeUrl, productId, service) => {
    const serviceId = service.id;
    const action = detectAction(type);
    changeAddRemoveState(type, action, RI_STATE_IN_PROGRESS);
    // Add to basket
    if (action === RI_ACTION_ADD) {
      try {
        const response = await addServiceToBasket(storeUrl, productId, serviceId);
        trackPSAServiceToBasket(service);
        basketIdRef.current = response.basketId;
        changeAddRemoveState(type, action, RI_STATE_SUCCESS);
      } catch (e) {
        changeAddRemoveState(type, action, RI_STATE_FAILURE);
      }
      // Remove from basket
    } else if (action === RI_ACTION_REMOVE && basketIdRef.current) {
      try {
        await removeServiceFromBasket(storeUrl, basketIdRef.current, productId, serviceId);
        trackPSAServiceOffBasket(service);
        changeAddRemoveState(type, action, RI_STATE_SUCCESS);
      } catch (e) {
        changeAddRemoveState(type, action, RI_STATE_FAILURE);
      }
    }
  };

  // PREXA-47 - R&I is temporarily disabled for bundles
  // It is not possible to add services to bundles at the moment
  const isRecycleAndInstallPossible = (recycleAndInstallEnabled, isDynamicBundle, isStaticBundle) =>
    recycleAndInstallEnabled && !(isDynamicBundle || isStaticBundle);

  // PSA WBW does not work correctly, if main product is bundle.
  const isWhenBoughtWithPossible = (psaWhenBoughtWithEnabled, isDynamicBundle, isStaticBundle) =>
    psaWhenBoughtWithEnabled && !(isDynamicBundle || isStaticBundle);

  const createDataForAnalytics = (attachments, whenBoughtWithEnabled) => ([
    attachments.productID,
    whenBoughtWithEnabled ? ANALYTICS_BUNDLE_TYPE_WBW : attachments.bundleType,
    attachments.recommendationType,
    attachments.attachments.map(
      (item) => {
        let attachmentData = {
          manufacturer: item.brandLabel,
          productID: item.id,
          productName: item.name,
          currentPrice: item.price &&
            typeof item.price.amount === 'number'
            ? item.price.amount / 100 : 0.00,
          wasPrice: item.wasPrice &&
            typeof item.wasPrice.amount === 'number'
            ? item.wasPrice.amount / 100 : 0.00,
          savingsPrice: item.wasPrice &&
            typeof item.wasPrice.discountAmount === 'number'
            ? item.wasPrice.discountAmount / 100 : 0.00
        };
        if (whenBoughtWithEnabled &&
        item.bundlePrice && item.bundlePrice.priceInBundle &&
        typeof item.bundlePrice.priceInBundle === 'number') {
          attachmentData = {
            ...attachmentData,
            currentPrice: item.bundlePrice.priceInBundle / 100,
            separatePrice: attachmentData.currentPrice
          };
        }
        return attachmentData;
      }
    )
  ]);

  const handleMainProductAdded = async (e) => {
    let mainProductId = e.detail.fupid;
    const basketRedirectUrl = e.detail.basketRedirectUrl;
    basketRedirectUrlRef.current = basketRedirectUrl;
    let attachments = attachmentsDataRef.current;

    // Added different product than current PDP product (e.g. from Tradeup, Compare)
    if (mainProductRef.current.productID !== mainProductId) {
      await loadMainProductData(storeUrl, mainProductId);
    }

    // Check if product is bundle
    setProductBundle(false);
    let isDynamicBundle = false;
    let isStaticBundle = false;
    setSubproductNames([]);

    // Dynamic Bundle was added from its main product PDP
    if (e.detail.mainProductId && e.detail.addonProductsIds && e.detail.addonProductsIds.length) {
      setMainProduct({
        ...mainProductRef.current,
        productPrice: parseFloat(e.detail.bundlePrice)
      });
      mainProductId = e.detail.mainProductId;
      const {
        mainProductSegmentId,
        // addonProductsIds,
        addonProductsNames,
        addonProductsSegmentIds
      } = e.detail;
      setProductBundle(true);
      isDynamicBundle = true;
      setSubproductNames(addonProductsNames);
      attachments = {
        ...attachments,
        attachments: filterAttachmentsBySegmentIds(
          attachments.attachments,
          [mainProductSegmentId, ...addonProductsSegmentIds]
        )
      };
    }

    // Static Bundle was added from it's own PDP
    if (staticBundleSubProducts && staticBundleSubProducts.length) {
      mainProductId = productID;

      const addonProductsNames = staticBundleSubProducts
        .map((subProduct) => subProduct.productName);
      const addonProductsSegmentIds = staticBundleSubProducts
        .map((subProduct) => subProduct.segmentId);
      setProductBundle(true);
      isStaticBundle = true;
      setSubproductNames(addonProductsNames);
      attachments = {
        ...attachments,
        attachments: filterAttachmentsBySegmentIds(attachments.attachments, addonProductsSegmentIds)
      };
    }

    // Disable PSA WBW for bundles
    setWhenBoughtWithPossible(isWhenBoughtWithPossible(
      psaWhenBoughtWithEnabled,
      isDynamicBundle,
      isStaticBundle
    ));

    // If product was added via collect in store, set store and delivery type
    if (e.detail.storeId && e.detail.deliveryType) {
      setStoreId(e.detail.storeId);
      setDeliveryType(e.detail.deliveryType);
    }

    // Check if R&I is switched on and product has some services, display R&I
    setRecycleAndInstallDisplayed(false);
    if (isRecycleAndInstallPossible(recycleAndInstallEnabled, isDynamicBundle, isStaticBundle) &&
        servicesDataRef.current && servicesDataRef.current.length) {
      servicesDataRef.current.forEach((service) => {
        if (service.type === RI_TYPE_RECYCLING) {
          const recycling = {
            type: RI_TYPE_RECYCLING,
            display: true,
            productId: service.id,
            typeText: recyclingLabel,
            productPrice: service.price.amountWithVat,
            buttonText: addButtonLabel,
            productCurrency: service.price.currency,
            moreInfoText: moreInfoLabel,
            addOnClick: () => {
              handleAddRemoveService(RI_TYPE_RECYCLING, storeUrl, mainProductId, service);
            },
            moreDetails: {
              isExpanded: false,
              html: recyclingHelpText,
              tooltipHtml: service.additionalInformation
            }
          };
          setRecyclingData(recycling);
          recyclingDataRef.current = recycling;
        }
        if (service.type === RI_TYPE_INSTALLATION) {
          const installation = {
            type: RI_TYPE_INSTALLATION,
            display: true,
            productId: service.id,
            typeText: installationLabel,
            productPrice: service.price.amountWithVat,
            buttonText: addButtonLabel,
            productCurrency: service.price.currency,
            moreInfoText: moreInfoLabel,
            addOnClick: () => {
              handleAddRemoveService(RI_TYPE_INSTALLATION, storeUrl, mainProductId, service);
            },
            moreDetails: {
              isExpanded: false,
              html: installationHelpText,
              tooltipHtml: service.additionalInformation
            }
          };
          setInstallationData(installation);
          installationDataRef.current = installation;
        }
      });
      setRecycleAndInstallDisplayed(true);
      setVisible(true);
      trackPSAServicesDisplayed(servicesDataRef.current);
    } else if ( // Otherwise display product attachments, if any
      attachments &&
      attachments.productID === mainProductId &&
      attachments.attachments && attachments.attachments.length
    ) {
      setAttachmentsData(attachments);
      setVisible(true);
      trackProductAttachmentsPopupDisplayed(
        ...createDataForAnalytics(attachments, psaWhenBoughtWithEnabled)
      );
    } else if ( // If product added (eg. via tradeup) is different than main product (currently displayed)
      attachments &&
      attachments.productID !== mainProductId &&
      attachments.attachments && attachments.attachments.length
    ) {
      // Load attachments
      const newAttachments = await fetchAttachments(storeUrl, mainProductId);
      setAttachmentsData(newAttachments);

      setVisible(true);
      trackProductAttachmentsPopupDisplayed(
        ...createDataForAnalytics(attachments, psaWhenBoughtWithEnabled)
      );
    } else { // If there are no attachments, redirect to basket
      window.location.href = basketRedirectUrl;
    }
  };

  React.useEffect(() => {
    if (!productID) {
      // eslint-disable-next-line no-console
      console.warn('Attachments can not be loaded, because main product ID is not defined.');
      return;
    }
    if (!storeUrl) {
      // eslint-disable-next-line no-console
      console.warn('Attachments can not be loaded, because API URL is not defined.');
      return;
    }
    if (
      mainProductData.productName &&
      mainProductData.productManufacturer &&
      mainProductData.productImgUrl &&
      mainProductData.productPrice &&
      !Number.isNaN(mainProductData.productPrice)
    ) {
      setMainProduct(mainProductData);
      mainProductRef.current = mainProductData;
    } else {
      loadMainProductData(storeUrl, productID);
    }
    loadAttachments(storeUrl, productID);
    loadServices(storeUrl, productID);
    document.addEventListener(ON_PSA_MAIN_PRODUCT_ADDED, handleMainProductAdded);
  }, []);

  const handleClose = () => {
    setVisible(false);
    trackGeneralEvent(
      'Product Interaction',
      'Pop-up Attach Closed',
      {},
      'attachPopupClosed'
    );
  };

  const handleAddToBasket = (mainProductID, attachmentProductID) => {
    trackGeneralEvent(
      'Product Interaction',
      'Pop-up Attach Add to Basket',
      {
        mainProductID,
        attachmentProductID
      },
      'attachPopupAddToBasket'
    );
  };

  const handleAddToBasketSuccess = (fupid, response) => {
    setAttachmentsAddedToBasket([...attachmentsAddedToBasket, fupid]);
    if (psaVariant === PSA_VARIANT_1) {
      if (response.basketConfirmationUrl) {
        window.location.href = response.basketConfirmationUrl;
      } else {
        // In case of PSA WBW, store is called directly, and tehre is not basket URL in the response
        // TODO - URL should be linked from fo-site
        window.location.href = '/app/basket';
      }
    }
  };

  const handleAddToBasketFailure = (fupid, error) => setProductIdForFailedAddToBasket(fupid);

  const handleContinueToBasket = () => {
    window.location.href = basketRedirectUrlRef.current;
  };

  if (isVisible === true) {
    return (
      <RightSidePopup
        onClose={() => { handleClose(); }}
        title={''}
        hideHeaderBar={hideHeaderBar}
      >
        {psaVariant === PSA_VARIANT_1 && !recycleAndInstallDisplayed &&
          attachmentsData && attachmentsData.attachments.length &&
          mainProduct &&
          mainProduct.productName && mainProduct.productManufacturer &&
          mainProduct.productImgUrl && mainProduct.productPrice && (
          <WrapperVariant1
            psaWhenBoughtWithEnabled={whenBoughtWithPossible}
            productName={mainProduct.productName}
            productManufacturer={mainProduct.productManufacturer}
            productImgUrl={mainProduct.productImgUrl}
            productPrice={mainProduct.productPrice}
            productID={
              mainProductData && mainProductData.productID
                ? mainProductData.productID // For static bundles, pass bundle ID (productID is the main product ID)
                : productID
            }
            storeId={storeId}
            deliveryType={deliveryType}
            isProductBundle={isProductBundle}
            subproductNames={subproductNames}
            attachments={attachmentsData.attachments.slice(0, 5)}
            attachmentsLabel={attachmentsLabel}
            continueToBasketButtonLabel={continueToBasketButtonLabel}
            continueShoppingButtonLabel={continueShoppingButtonLabel}
            addAttachmentInBasketLabel={addAttachmentInBasketLabel}
            addAttachmentInBasketInProgressLabel={addAttachmentInBasketInProgressLabel}
            attachmentAddedInBasketLabel={attachmentAddedInBasketLabel}
            continueToBasketButtonAction={handleContinueToBasket}
            continueShoppingButtonAction={handleClose}
            onAddToBasket={handleAddToBasket}
            onAddToBasketSuccess={handleAddToBasketSuccess}
            onAddToBasketFailure={handleAddToBasketFailure}
            productIdForFailedAddToBasket={productIdForFailedAddToBasket}
            headerItemLabel={headerItemLabel}
            headerBundleLabel={headerBundleLabel}
            storeUrl={storeUrl}
          />
        )}

        {psaVariant === PSA_VARIANT_2 && !recycleAndInstallDisplayed &&
          attachmentsData && attachmentsData.attachments.length && (
          <WrapperVariant2
            productID={productID}
            attachments={attachmentsData.attachments.slice(0, 5)}
            attachmentsAddedToBasket={attachmentsAddedToBasket}
            attachmentsLabel={attachmentsLabel}
            continueToBasketButtonLabel={continueToBasketButtonLabel}
            continueShoppingButtonLabel={continueShoppingButtonLabel}
            addAttachmentInBasketLabel={addAttachmentInBasketLabel}
            addAttachmentInBasketInProgressLabel={addAttachmentInBasketInProgressLabel}
            attachmentAddedInBasketLabel={attachmentAddedInBasketLabel}
            continueToBasketButtonAction={handleContinueToBasket}
            continueShoppingButtonAction={handleClose}
            basketInfoLabel1={basketInfoLabel1}
            basketInfoLabel2Singular={basketInfoLabel2Singular}
            basketInfoLabel2Plural={basketInfoLabel2Plural}
            onAddToBasket={handleAddToBasket}
            onAddToBasketSuccess={handleAddToBasketSuccess}
            onAddToBasketFailure={handleAddToBasketFailure}
            productIdForFailedAddToBasket={productIdForFailedAddToBasket}
            psaWhenBoughtWithEnabled={psaWhenBoughtWithEnabled}
          />
        )}

        {recycleAndInstallDisplayed && (
          <Wrapper
            productName={mainProduct.productName}
            productManufacturer={mainProduct.productManufacturer}
            productImgUrl={mainProduct.productImgUrl}
            productPrice={mainProduct.productPrice}
            isProductBundle={isProductBundle}
            continueToBasketButtonLabel={continueToBasketButtonLabel}
            continueShoppingButtonLabel={continueShoppingButtonLabel}
            continueToBasketButtonAction={handleContinueToBasket}
            continueShoppingButtonAction={handleClose}
            headerItemLabel={headerItemLabel}
            headerBundleLabel={headerBundleLabel}
            weHelpHeadingLabel={weHelpHeadingLabel}
            installation={installationData}
            recycling={recyclingData}
            installationInProgress={installationInProgress}
            recyclingInProgress={recyclingInProgress}
            recyclingFailed={recyclingFailed}
            installationFailed={installationFailed}
            failedToUpdateBasket={failedToUpdateBasket}
            pleaseTryAgain={pleaseTryAgain}
          />
        )}
      </RightSidePopup>
    );
  }

  return null;
};

PSAPopup.propTypes = {
  psaVariant: PropTypes.string.isRequired,
  recycleAndInstallEnabled: PropTypes.bool,
  psaWhenBoughtWithEnabled: PropTypes.bool,
  productID: PropTypes.string.isRequired,
  mainProductData: PropTypes.shape({
    productID: PropTypes.string,
    productName: PropTypes.string,
    productManufacturer: PropTypes.string,
    productImgUrl: PropTypes.string,
    productPrice: PropTypes.number,
    segmentId: PropTypes.number
  }),
  staticBundleSubProducts: arrayOf(PropTypes.shape({
    productID: PropTypes.string,
    productName: PropTypes.string,
    segmentId: PropTypes.number
  })),
  storeUrl: PropTypes.string.isRequired,
  hideHeaderBar: PropTypes.bool,
  attachmentsLabel: PropTypes.string.isRequired,
  continueToBasketButtonLabel: PropTypes.string.isRequired,
  continueShoppingButtonLabel: PropTypes.string.isRequired,
  addAttachmentInBasketLabel: PropTypes.string.isRequired,
  addAttachmentInBasketInProgressLabel: PropTypes.string.isRequired,
  attachmentAddedInBasketLabel: PropTypes.string.isRequired,
  basketInfoLabel1: PropTypes.string.isRequired,
  basketInfoLabel2Singular: PropTypes.string.isRequired,
  basketInfoLabel2Plural: PropTypes.string.isRequired,
  headerItemLabel: PropTypes.string.isRequired,
  headerBundleLabel: PropTypes.string.isRequired,
  recyclingLabel: PropTypes.string.isRequired,
  installationLabel: PropTypes.string.isRequired,
  recyclingHelpText: PropTypes.string.isRequired,
  installationHelpText: PropTypes.string.isRequired,
  weHelpHeadingLabel: PropTypes.string.isRequired,
  failedToUpdateBasket: PropTypes.string.isRequired,
  pleaseTryAgain: PropTypes.string.isRequired,
  addButtonLabel: PropTypes.string.isRequired,
  removeButtonLabel: PropTypes.string.isRequired,
  moreInfoLabel: PropTypes.string.isRequired,
  forceVisible: PropTypes.bool
};

PSAPopup.defaultProps = {
  recycleAndInstallEnabled: false,
  psaWhenBoughtWithEnabled: false,
  mainProductData: {},
  staticBundleSubProducts: [],
  hideHeaderBar: true,
  forceVisible: false
};

export default PSAPopup;

